import { GET_LABELS, GET_LABELS_Name } from "../actions/types";
import axios from "axios";
import { getLanguages } from "./languageAction";
const PROXY = process.env.REACT_APP_URL + "api/";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const getLabels = () => async (dispatch) => {
  const res = await axios.get(PROXY + "label/get-label");
  dispatch({
    type: GET_LABELS,
    payload: res.data.result,
  });
  return res;
};

export const getLabelVersion = () => async (dispatch) => {
  const res = await axios.get(PROXY + "label/version");

  if(localStorage.getItem('property-label-version')){
    if(localStorage.getItem('property-label-version' ) != res.data.result.type_3_version){
    
      localStorage.setItem('property-label-version' , res.data.result.type_3_version)
      dispatch(getLabelsName())
    }
  }
  else{
    localStorage.setItem('property-label-version' , res.data.result.type_3_version)
  dispatch(getLabelsName())
  }
return res.data.result.type_3_version
}

export const getLabelsName =
  (language = "en", type = 3, version = "", pl = "") =>
  async (dispatch) => {
    const langResult = await dispatch(getLanguages());

    const defLang = langResult.find((element) => element.default === 1);

    language = localStorage.getItem("i18nextFront") || defLang?.language_code ;
    localStorage.setItem("prevLangFront", language);
    version = localStorage.getItem("frontversion") || 0;
    pl = localStorage.getItem("prevLangFront") || 0;
    const res = await axios.get(
      `${PROXY}label/get-label?language=${language}&type=${type}&version=${version}&pl=${pl}`
    );
    localStorage.setItem("frontversion", res?.data?.result[0].version);
   
 
   
    if (res?.data?.result?.length > 0) {
      dispatch({
        type: GET_LABELS_Name,
        payload: res.data.result,
      });
    }
  };
